module.exports = __webpack_public_path__ + "media/images/athletes/4161-a17b6c2ef8c8bca4b4804923c806ca65.png";